import { ContactLogButton } from 'legacy/lut/components/widgets/public/ContactLogButton'
import { FC, useEffect, useState } from 'react'

import { Input } from 'core-components/library/inputs'
import { Loader } from 'core-components/library/loader'
import Logger from 'core/utils/Logger'

import { getAdditionalData } from './helpers/getAdditionalData'
import { getContactBasicInfo } from './helpers/getContactBasicInfo'
import { getContactConnectionInfo } from './helpers/getContactConnectionInfo'
import { getContactDetails } from './helpers/getContactDetails'
import { getParsedData } from './helpers/getParsedData'
import { getRequestClass } from './helpers/getRequestClass'
import { getRequestIcon } from './helpers/getRequestIcon'
import { IContactAdditionalRowProps } from './models'

import styles from './ContactAdditionalRow.module.scss'

export const ContactAdditionalRow: FC<IContactAdditionalRowProps> = ({ contactId, contact }) => {
  const [isLoading, setLoading] = useState(true)
  const [contactCampaigns, setContactCampaigns] = useState<any[]>([])
  const [userRights, setUserRights] = useState<any[]>([])
  const [contactCampaignsFilter, setContactCampaignsFilter] = useState('')
  const [userRightsFilter, setUserRightsFilter] = useState('')
  const [showAllCampaigns, setShowAllCampaigns] = useState(false)
  const [showAllUserRights, setShowAllUserRights] = useState(false)

  Logger.log('ContactAdditionalRow', { contact })

  useEffect(() => {
    setLoading(true)
    getAdditionalData(contactId)
      .then((data) => {
        setContactCampaigns(data.ContactCampaigns)
        setUserRights(data.UserRights)
        setContactCampaignsFilter('')
        setUserRightsFilter('')
        setShowAllCampaigns(false)
        setShowAllUserRights(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [contactId])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.root}>
      <div className={styles.col}>
        <p className={styles.title}>Details Contact</p>
        {getContactDetails({ contact }).map(({ label, value }) => (
          <div className={styles.data} key={label}>
            <p className={styles.data__label}>{label}:</p>
            <p className={styles.data__value}>{value}</p>
          </div>
        ))}
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Connect</p>
        {getContactConnectionInfo({ contact }).map(({ label, value }) => (
          <div className={styles.data} key={label}>
            <p className={styles.data__label}>{label}:</p>
            <p className={styles.data__value}>{value}</p>
          </div>
        ))}
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Location & User</p>
        {getContactBasicInfo({ contact }).map(({ label, value }) => (
          <div className={styles.data} key={label}>
            <p className={styles.data__label}>{label}:</p>
            <p className={styles.data__value}>{value}</p>
          </div>
        ))}
      </div>

      <div className={styles.col}>
        <p className={styles.title}>User Rights</p>
        <Input
          classes={{
            root: styles.input,
          }}
          placeholder={'Search...'}
          onChange={(val) => setUserRightsFilter(val)}
        />
        {getParsedData(userRights, 'USER_RIGHTS', userRightsFilter, showAllUserRights).map(
          (item: any, index: any) => (
            <div key={index} className={styles.requests}>
              {getRequestIcon({ modified: item.Modified, status: item.Status, styles })}
              {item.USER_RIGHTS ? (
                <span>{item.USER_RIGHTS}</span>
              ) : (
                <span
                  className={getRequestClass({
                    action: item.Action,
                    modified: item.Modified,
                    status: item.Status,
                    styles,
                  })}
                >
                  {item.Code}
                </span>
              )}
            </div>
          )
        )}
        {!showAllUserRights && userRights.length > 5 ? (
          <div className={styles.moreBtn} onClick={() => setShowAllUserRights(true)}>
            More
          </div>
        ) : null}
        {!userRights.length && <div>Not found</div>}
      </div>

      <div className={styles.col}>
        <p className={styles.title}>Campaigns</p>
        <Input
          placeholder={'Search...'}
          classes={{
            root: styles.input,
          }}
          onChange={(val) => setContactCampaignsFilter(val)}
        />
        {getParsedData(contactCampaigns, 'CAMPAIGNS', contactCampaignsFilter, showAllCampaigns).map(
          (item: any, index: any) => (
            <div key={index} className={styles.requests}>
              {getRequestIcon({ modified: item.Modified, status: item.Status, styles })}
              {item.CAMPAIGNS ? (
                <span>{item.CAMPAIGNS}</span>
              ) : (
                <span
                  className={getRequestClass({
                    action: item.Action,
                    modified: item.Modified,
                    status: item.Status,
                    styles,
                  })}
                >
                  {item.Code}
                </span>
              )}
            </div>
          )
        )}
        {!showAllCampaigns && contactCampaigns.length > 5 ? (
          <div className={styles.moreBtn} onClick={() => setShowAllCampaigns(true)}>
            More
          </div>
        ) : null}
        {!contactCampaigns.length && <div>Not found</div>}
      </div>

      <div className={styles.col}>
        <ContactLogButton contactID={contact.ContactID} />
      </div>
    </div>
  )
}
